import { FieldValues, UseFormRegister } from 'react-hook-form';

import Input from '../../../components/form/Input';
import { IConfigItemType } from '../validates/sectionBuilderSchema';

import RenderObjectLabel from './RenderObjectLabel';

export interface IPropsEbookItem {
  type: IConfigItemType.Ebook;
  _id?: string;
}

interface IPropsEbookSectionItem {
  index: number;
  itemData: IPropsEbookItem;
  register: UseFormRegister<FieldValues>;
  onDeleteSectionItem?: (deleteIndex?: number) => void;
  expanded?: boolean;
}

const EbookSectionItem = (props: IPropsEbookSectionItem) => {
  const { index, itemData, register, expanded } = props;

  return (
    <div className="flex justify-between space-x-16">
      <div className="w-full collapse">
        <input type="checkbox" className="peer" defaultChecked={expanded} />
        <div className=" collapse-title bg-systemGrays08FillQuaternary text-systemGrays01LabelPrimary peer-checked:bg-systemGrays08FillQuaternary peer-checked:text-systemGrays01LabelPrimary flex justify-between after:content-['+'] peer-checked:after:content-['-'] ease-out duration-300">
          <span>
            <span>Ebook </span>
            <RenderObjectLabel objectLists={[{ key: 'ebook Id', value: itemData?._id, required: true }]} />
          </span>
        </div>
        <div className="collapse-content text-systemGrays01LabelPrimary peer-checked:bg-systemGrays08FillQuaternary peer-checked:text-systemGrays01LabelPrimary">
          <div className="space-y-8">
            <Input register={register} required label="ebook Id" name={`configItems.${index}._id`} helperText="Input ebook ID" placeholder="ebook ID" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EbookSectionItem;
